import { useState } from "react";

import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";

import { Loading } from "@components";
import { If } from "shared/components/control-statements";
import { OlgaEnvironmentsAPI } from "../../../../providers/OlgaEnvironmentsAPI";
import styles from "../../../../styles/beneficios/CreateFolderDrawer.module.scss";
import { Icon } from "../../../components/core/Icon";
import { Folder } from "../../../core/Folder";

export default function CreateFolderDrawer({
  folders,
  visible,
  onClose,
  onRemove,
  onUpdateFolders,
  onAddFolders,
  loading,
}) {
  const [folderName, setFolderName] = useState("");
  const [saving, setSaving] = useState(false);

  const addFolder = () => {
    if (folderName.length === 0) return;

    const existingFolder = folders.find(
      (existingFolder) => existingFolder.name === folderName
    );

    if (!existingFolder) {
      const folder = new Folder({ name: folderName });
      onUpdateFolders([folder, ...folders]);
    }

    setFolderName("");
  };

  const removeFolder = (folder) => {
    if (folder.isNew) {
      onUpdateFolders(
        folders.filter((currentFolder) => currentFolder.id != folder.id)
      );
    } else {
      onRemove(folder);
    }
  };

  const saveFolders = async () => {
    setSaving(true);

    const currentFolders = await getFolders();
    const newFolders = folders.filter((folder) => folder.isNew);
    const updatedFolders = [...newFolders, ...currentFolders];

    const saveReq = await OlgaEnvironmentsAPI.putConfigurations({
      coupon_folders: updatedFolders,
    });

    if (saveReq.getErrors([]).length > 0) {
      alert({ text: saveReq.getErrors()[0] });
    } else {
      onAddFolders();
    }

    setSaving(false);
    onClose();
  };

  const getFolders = async () => {
    const environmentConfigurations =
      await OlgaEnvironmentsAPI.getConfigurations();
    return environmentConfigurations.getData({})?.coupon_folders || [];
  };

  return (
    <Drawer onClose={onClose} title="Pastas" visible={visible}>
      <div className={styles.createFolder}>
        <Label>Insira o nome da nova pasta</Label>
        <Input
          placeholder="Nome da pasta"
          onChange={(e) => setFolderName(e.target.value)}
          value={folderName}
        />
        <Button
          design="default-2"
          className="mt-15 w-100"
          onClick={addFolder}
          disabled={!folderName}
        >
          Adicionar
        </Button>

        <Hairline solid className="mt-30 mb-30" />

        <Label>Pastas ({folders.length})</Label>

        <If cond={loading}>
          <div className={styles.folders}>
            <div className="h-100 d-flex align-center justify-center">
              <Loading />
            </div>
          </div>
        </If>

        <If cond={!loading}>
          {folders.length === 0 ? (
            <div className={styles.empty}>
              <div className={styles.icon}>
                <Icon name="folder-open" />
              </div>

              <p>Não há pastas criadas no momento.</p>
              <span>
                Por meio desta ferramenta, será possível organizar os seus
                benefícios por pastas.
              </span>
            </div>
          ) : (
            <div className={styles.folders}>
              {folders.map((folder) => (
                <div className={styles.folder} key={folder.id}>
                  <p>{folder.name}</p>
                  <div
                    className={styles.remove}
                    onClick={() => removeFolder(folder)}
                  >
                    <Icon name="times" />
                  </div>
                </div>
              ))}
            </div>
          )}
        </If>

        <div className={styles.footer}>
          <Button
            className="w-100"
            onClick={saveFolders}
            disabled={saving}
            design="primary"
            loading={saving}
          >
            Salvar
          </Button>
        </div>
      </div>
    </Drawer>
  );
}
